import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { TimeInputModule } from '../time-input/time-input.module';
import { DateWithTimeControlComponent } from './date-with-time-control.component';

@NgModule({
  declarations: [DateWithTimeControlComponent],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatLuxonDateModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatTimepickerModule,
    TimeInputModule,
  ],
  exports: [DateWithTimeControlComponent],
})
export class DateWithTimeControlModule {}
